import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Modal,
  Radio,
  Space,
  Tooltip,
  Typography
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  getCoberturaLabel,
  getCostoLabel
} from '../functions/opcionesSubcobertura';
import { getDescripcionOpcion } from '../utils';
import { formatoMonedaGenerico } from '../utils/converters';
import { InputIconEdit } from './InputIcons';
import TableAndFilters from './TableAndFilters';

const SelectableListModalCoberturas = ({
  columnsData,
  url,
  controlProductoCoberturas,
  setControlProductoCoberturas,
  title,
  width = 500,
  idAseguradora,
  idProducto,
  iconButton,
  data,
  handleChange,
  disabledButton = false
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkedList, setCheckedList] = useState([]); // Lista para checkbox
  const [columns, setColumns] = useState([]);
  const tableRef = useRef();

  const CoberturaReemplazoSelectableModal = ({
    label,
    placeholder,
    innerColumnsData,
    innerUrl,
    initialValue,
    rowRecord,
    expandable
  }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [value, setValue] = useState(null); // Value para radioButton
    const [innerColumns, setInnerColumns] = useState([]);
    const ref = useRef();

    const onDeselect = () => {
      let newList = [];
      const duplicado = checkedList.filter(
        (item) => item.id_subcobertura === rowRecord.id
      );

      let id;
      if (duplicado.length > 1) {
        for (let j = 0; j < duplicado.length; j += 1) {
          const item = duplicado[j];
          if (item.id) {
            id = item.id;
          }
        }

        for (let i = 0; i < checkedList.length; i += 1) {
          const c = checkedList[i];
          if (c.id_subcobertura === rowRecord.id && !c.id) {
            c.id = id;
          }
        }
      }

      for (let i = 0; i < checkedList.length; i += 1) {
        const c = checkedList[i];
        if (c.id_subcobertura === rowRecord.id) {
          if (c.id_subcobertura_reemplazo !== null && c.id) {
            c.id_subcobertura_reemplazo = null;
            c.subcR.cobertura.descripcion = '';
            c.agregado = true;
          }
          if (c.id_subcobertura_reemplazo !== null && !c.id) {
            c.eliminado = true;
          }
        }
        newList.push(c);
      }

      newList = newList.filter((item) => !item.eliminado);

      setControlProductoCoberturas([...newList]);
      handleChange([...newList], data);
    };

    const onOk = () => {
      let newValues = {};
      let encontrado = false;

      const newList = [];
      for (let i = 0; i < checkedList.length; i += 1) {
        const c = checkedList[i];
        if (c.id_subcobertura === rowRecord.id) {
          encontrado = true;
          c.agregado = true;
          c.id_subcobertura_reemplazo = value.id;
          c.subcR = {
            ...value,
            cobertura: { descripcion: value.cobertura?.descripcion }
          };
        }
        newList.push(c);
      }

      let datos;
      if (!encontrado) {
        newValues = {
          subcobertura: rowRecord,
          id_subcobertura: rowRecord.id,
          id_subcobertura_reemplazo: value.id,
          agregado: true,
          subcR: {
            ...value,
            cobertura: { descripcion: value.cobertura?.descripcion }
          }
        };
        datos = [...newList, newValues];
        setControlProductoCoberturas(data);
      } else {
        datos = [...newList];
        setControlProductoCoberturas(data);
      }

      // if (setData) setData(data);
      setCheckedList(datos);
      handleChange(datos, data);

      setIsVisible(false);
    };

    const onCancel = () => {
      clearAll();
      setIsVisible(false);
    };

    const clearAll = () => {
      if (controlProductoCoberturas && controlProductoCoberturas.length > 0) {
        setValue(
          controlProductoCoberturas.find(
            (item) => item.id_subcobertura_reemplazo
          )
        );
      }
    };

    const onChangeRadio = useCallback(async (e, record) => {
      setValue(record);
    }, []);

    useEffect(() => {
      setInnerColumns([
        ...innerColumnsData,
        {
          title: 'Seleccionar',
          key: 'action',
          dataIndex: ' ',
          width: '10px',
          align: 'left',
          render: (text, record) => {
            const listaFinal = checkedList;
            return (
              <Space
                size="small"
                // style={{ textAlign: 'center', display: 'initial' }}
              >
                <Radio.Group
                  onChange={(e) => onChangeRadio(e, record)}
                  value={value?.id_subcobertura_reemplazo || value?.id}
                >
                  <Radio
                    disabled={
                      listaFinal && listaFinal.length
                        ? (listaFinal.filter(
                            (item) =>
                              item.id_subcobertura_reemplazo === record.id
                          ).length > 0 ||
                            listaFinal.filter(
                              (item) => item.id_subcobertura === record.id
                            ).length > 0) &&
                          !listaFinal.filter(
                            (item) =>
                              item.id_subcobertura_reemplazo === record.id &&
                              item.id_subcobertura === rowRecord.id
                          ).length > 0
                        : false
                    }
                    key={record.id}
                    value={record.id}
                  />
                </Radio.Group>
              </Space>
            );
          }
        }
      ]);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, innerColumnsData, onChangeRadio]);

    useEffect(() => {
      if (initialValue.length) {
        setValue(initialValue[0]);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <>
        <Space>
          {initialValue.length ? (
            <Typography.Text>
              {initialValue[0]?.subcR?.cobertura?.descripcion ? (
                `
                              ${
                                initialValue[0]?.subcR.cobertura.descripcion
                              } | Tipo: ${getDescripcionOpcion(
                  initialValue[0]?.subcR.opcion
                )} - Cobertura: ${
                  getCoberturaLabel(initialValue[0]?.subcR)
                    ? getCoberturaLabel(initialValue[0]?.subcR).label
                    : ''
                }
                          ${
                            getCostoLabel(initialValue[0]?.subcR)
                              ? ` - Costo: ${getCostoLabel(
                                  initialValue[0]?.subcR
                                )}`
                              : ''
                          }
                          ${
                            initialValue[0]?.subcR.costo_min
                              ? ` - Costo Mínimo: ${formatoMonedaGenerico(
                                  initialValue[0]?.subcR.moneda,
                                  initialValue[0]?.subcR.costo_min
                                )}`
                              : ''
                          }
                          ${
                            initialValue[0]?.subcR.costo_max
                              ? ` - Costo Máximo: ${formatoMonedaGenerico(
                                  initialValue[0]?.subcR.moneda,
                                  initialValue[0]?.subcR.costo_max
                                )}`
                              : ''
                          }
                          - ${initialValue[0]?.subcR?.moneda?.simbolo || ''}
                        `
              ) : (
                <Typography.Text type="secondary">
                  Sin cobertura de reemplazo{' '}
                </Typography.Text>
              )}{' '}
            </Typography.Text>
          ) : (
            <Typography.Text type="secondary">
              Sin cobertura de reemplazo{' '}
            </Typography.Text>
          )}
          {checkedList.filter((item) => item.id_subcobertura === rowRecord.id)
            .length ? (
            <InputIconEdit onClick={() => setIsVisible(true)} />
          ) : null}
        </Space>

        <Modal
          title={label}
          open={isVisible}
          destroyOnClose
          width={width}
          footer={[
            <Button onClick={() => onCancel()}>Cancelar</Button>,
            <Button onClick={() => onDeselect()}>Deseleccionar</Button>,
            <Button type="primary" disabled={!value} onClick={() => onOk()}>
              Aceptar
            </Button>
          ]}
        >
          {columns.length > 0 && (
            <>
              <TableAndFilters
                ref={ref}
                withGeneralFilter
                url={innerUrl}
                columns={innerColumns}
                showTable
                hasExportar={false}
                expandable={expandable}
                tableLayout="auto"
                placeholder={placeholder}
              />
            </>
          )}
        </Modal>
      </>
    );
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setControlProductoCoberturas(checkedList);

    handleChange(checkedList, data);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };

  const clearAll = () => {
    if (checkedList && checkedList.length) {
      setCheckedList(controlProductoCoberturas.map((item) => item));
    }
  };

  const onChange = useCallback(
    async (e, record) => {
      const checkedValue = {
        id_subcobertura: record.id,
        id_subcobertura_reemplazo: null
      };

      const existe = checkedList.find(
        (item) => item.id_subcobertura === checkedValue.id_subcobertura
      );
      if (existe) {
        const newCheckeds = checkedList.filter(
          (item) => item.id_subcobertura !== checkedValue.id_subcobertura
        );

        setCheckedList(newCheckeds);
      } else {
        setCheckedList([...checkedList, checkedValue]);
      }
    },
    [checkedList]
  );

  useEffect(() => {
    setColumns([
      ...columnsData,
      {
        title: 'Subcobertura Reemplazo',
        key: 'subcobertura_reemplazo',
        align: 'right',
        render: (_, record) => {
          let initialValue = [];
          if (
            controlProductoCoberturas &&
            controlProductoCoberturas.length > 0
          ) {
            initialValue = controlProductoCoberturas.filter(
              (item) => item.id_subcobertura === record.id
            );
          }
          return (
            <>
              <CoberturaReemplazoSelectableModal
                label="Listado de subcoberturas"
                placeholder="Buscar subcoberturas"
                innerColumnsData={[
                  {
                    title: 'Descripción',
                    dataIndex: ['cobertura', 'descripcion'],
                    key: ['cobertura', 'descripcion']
                  },
                  {
                    title: 'Tipo',
                    dataIndex: ['opcion'],
                    key: ['opcion'],
                    render: (text, r) => {
                      return getDescripcionOpcion(r.opcion);
                    }
                  },
                  {
                    title: 'Cobertura',
                    render: (text, r) => {
                      const coberturaObj = getCoberturaLabel(r);
                      return coberturaObj ? coberturaObj.label : '';
                    }
                  },
                  {
                    title: 'Costo',
                    render: (text, r) => {
                      return getCostoLabel(r);
                    }
                  },
                  {
                    title: 'Costo Mínimo',
                    render: (text, r) => {
                      return (
                        r.costo_min &&
                        formatoMonedaGenerico(r.moneda, r.costo_min)
                      );
                    }
                  },
                  {
                    title: 'Costo Máximo',
                    render: (text, r) => {
                      return (
                        r.costo_max &&
                        formatoMonedaGenerico(r.moneda, r.costo_max)
                      );
                    }
                  },
                  {
                    title: 'Grupo',
                    dataIndex: ['cobertura', 'grupo', 'descripcion'],
                    key: ['cobertura', 'grupo', 'descripcion']
                  },
                  {
                    title: 'Moneda',
                    dataIndex: ['moneda', 'simbolo'],
                    key: ['moneda', 'simbolo']
                  }
                ]}
                innerUrl={`/cobertura/search/subcobertura?idAseguradora=${idAseguradora}&idProducto=${idProducto}`}
                initialValue={initialValue}
                rowRecord={record}
                /* expandable={{
                    expandedRowRender: () => (
                      <ExpandedCoberturas record={record} />
                    ),
                    rowExpandable: () => true
                  }} */
              />
            </>
          );
        }
      },
      {
        title: 'Acciones',
        key: 'action',
        width: '10px',
        align: 'left',
        render: (text, record) => {
          const lista = checkedList;
          let listaFinal = [];
          for (let i = 0; i < lista.length; i += 1) {
            const elemento = lista[i];
            listaFinal = lista.filter(
              (item) => item.id_subcobertura === elemento.id_subcobertura
            );
          }
          return (
            <Space
              size="small"
              style={{ textAlign: 'center', display: 'initial' }}
            >
              <>
                <Checkbox
                  key={record.id_subcobertura}
                  disabled={
                    listaFinal && listaFinal.length
                      ? listaFinal.filter(
                          (item) => item.id_subcobertura_reemplazo === record.id
                        ).length > 0
                      : false
                  }
                  checked={
                    !!checkedList.find(
                      (item) => item.id_subcobertura === record.id
                    )
                  }
                  onChange={(e) => onChange(e, record)}
                />
              </>
            </Space>
          );
        }
      }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedList, columnsData, onChange]);

  useEffect(() => {
    if (controlProductoCoberturas) {
      setCheckedList(controlProductoCoberturas);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Tooltip title={title}>
        <Button
          icon={iconButton || <PlusOutlined />}
          type="text"
          size="middle"
          onClick={showModal}
          style={{ color: 'rgba(0,0,0,.45)' }}
          disabled={disabledButton}
        />
      </Tooltip>

      <Modal
        title={title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={width}
      >
        {columns.length > 0 && (
          <>
            <TableAndFilters
              ref={tableRef}
              withGeneralFilter
              url={url}
              columns={columns}
              showTable
              hasExportar={false}
            />
          </>
        )}
      </Modal>
    </>
  );
};

export default SelectableListModalCoberturas;
